var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-bao2"},[_c('h1',[_vm._v("home pdaged")]),_vm._v(" "+_vm._s(_vm.$store.getters['test'])+" "+_vm._s(_vm.$store.getters['moduleA/moduleState'])+" "+_vm._s(_vm.$.handleAssetsUrl('/sfsf.png'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }